import React from "react";

const ModerationCountContext = React.createContext(null);

export default ModerationCountContext;
